"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseClass2 = require("./BaseClass");

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Contract = function (_BaseClass) {
  _inherits(Contract, _BaseClass);

  /**
   * Id des Vertrags
   * @type {string}
   */

  /**
   * Id des Vertragsinhabers
   * @type {string}
   */

  /**
   * Vertragsnummer
   * @type {string}
   */

  /**
   * Name des Tickets
   * @type {string}
   */

  /**
   * Ident des Tickets
   * @type {string}
   */

  /**
   * Vertrag ist gültig von
   * @type {date}
   */

  /**
   * Vertrag ist gültig bis
   * @type {date}
   */

  /**
   * Status des Vertrags (z.B. gekündigt, aktive,...)
   * @type {string}
   */

  /**
   * Id zum Status
   * @type {integer}
   */

  /**
   * Name des Kunden
   * @type {string}
   */

  /**
   * Übergeordnete Kunde vom Vertragskunden
   * @type {string}
   */

  /**
   * Name des Ticketinhabers
   * @type {string}
   */
  function Contract() {
    _classCallCheck(this, Contract);

    var _this = _possibleConstructorReturn(this, (Contract.__proto__ || Object.getPrototypeOf(Contract)).call(this));

    _this.Id = "";
    _this.IdCustomer = "";
    _this.ContractNumber = "";
    _this.TicketName = "";
    _this.DateFrom = new Date();
    _this.DateTo = new Date();
    _this.Status = "";
    _this.StatusId = 0;
    _this.CustomerName = "";
    _this.CustomerAbove = "";
    _this.TicketCustomer = "";
    _this.ExternalDescription = "";
    _this.TicketIdent = "";
    return _this;
  }
  /**
   * Status Extern
   * @type {string}
   */


  return Contract;
}(_BaseClass3.default);

exports.default = Contract;